module.exports = {"230716001":"为民社区","230716002":"安民社区","230716003":"便民社区","230716004":"乐民社区","230716400":"山峰林场","230716401":"阳光林场","230716402":"新风林场","230716403":"卫国林场","230716404":"查山经营所","230716405":"长青经营所","230716406":"青山农场","230716407":"溪水经营所","230716408":"蔚兰经营所","230716409":"永绪经营所","230716410":"美林经营所","230716411":"红山经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230716.json
// module id = 755
// module chunks = 0